import { render, staticRenderFns } from "./ModernTextInput.vue?vue&type=template&id=0ee98ef1&"
import script from "./ModernTextInput.vue?vue&type=script&lang=js&"
export * from "./ModernTextInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports